import React, { useContext, useEffect, useState } from 'react';
import { Table, ApplicationUIContext } from '@yuhuinc/ui-library';
import { Divider, Space, Typography } from 'antd';
import { FolderOpenOutlined } from '@ant-design/icons';

import { getDocuments } from '../api/cotenants';
import TitleWithIcon from '../common/TitleWithIcon';

const { Link } = Typography;

const APPLICANT_DOCUMENTS_COLUMNS = [
  {
    title: 'Document',
    dataIndex: 'url',
    key: 'url',
    render(value) {
      return <Link href={value.url}>{value.name}</Link>;
    },
  },
  {
    title: 'Added',
    dataIndex: 'created_at',
    key: 'created_at',
  },
];

const ApplicationDocuments = ({ cotenantId }) => {
  const [documents, setDocuments] = useState([]);
  const { isMobile } = useContext(ApplicationUIContext);

  useEffect(() => {
    getDocuments(cotenantId).then(({ documents }) => {
      setDocuments(documents);
    });
  }, [cotenantId]);

  if (!documents || documents.length === 0) return null;

  return (
    <>
      <Divider />
      <Space direction="vertical" style={{ width: '100%' }}>
        <TitleWithIcon icon={<FolderOpenOutlined />} text="Documents" />
      </Space>

      <Table
        dataSource={documents}
        columns={APPLICANT_DOCUMENTS_COLUMNS}
        hideActionAndSearch
        size={isMobile ? 'middle' : 'small'}
        scroll={{
          x: isMobile,
        }}
        pagination={{ hideOnSinglePage: true }}
      />
    </>
  );
};

export default ApplicationDocuments;
